import { ChatUserData } from "@virtualprogaming/js-public-sdk";
import { useQuery, UseQueryOptions } from "react-query";

import { useChatApi } from "./useChatApi";

export function useChatUsers(
  top: number,
  options?: UseQueryOptions<ChatUserData>
) {
  const api = useChatApi();
  return useQuery({
    queryKey: ["chat-users", top],
    queryFn: async () => {
      const { data } = await api.getUsers(undefined, top, undefined);
      return data;
    },
    ...options,
  });
}
